import React, { useContext, useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { FaEnvelope } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { InfoContext } from "../providers/InfosContextProvider";

const Contact = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id") ?? "";

  const { texts } = useContext(InfoContext);

  const [showAlert, setShowAlert] = useState(false);
  const [showError, setShowError] = useState(false);

  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
    mensagem: "",
  });

  useEffect(() => {
    if (id) {
      setFormData((prevData) => ({
        ...prevData,
        mensagem: `${texts.contacts.queroSaberMais}${id}.`,
      }));
    }
  }, [id, texts.contacts.queroSaberMais]);

  useEffect(() => {
    const pageTitle = texts?.contacts?.titulo || "Contactos";
    document.title = `${pageTitle} | Casas do Nabão`;
  }, [texts]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Envia os dados do formulário para o script PHP
    const data = new FormData();
    Object.keys(formData).forEach((key) => data.append(key, formData[key]));
    data.append("type", "contact");

    fetch("/api/send-email.php", {
      method: "POST",
      body: data,
    })
      .then((response) => {
        if (response.status === 200) {
          setShowAlert(true);
          setShowError(false);
          setFormData({
            nome: "",
            email: "",
            telefone: "",
            mensagem: "",
          });
        } else {
          setShowAlert(false);
          setShowError(true);
        }
      })
      .catch(() => {
        setShowAlert(false);
        setShowError(true);
      });
  };

  useEffect(() => {
    if (showAlert || showError) {
      const timer = setTimeout(() => {
        setShowAlert(false);
        setShowError(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showAlert, showError]);

  return (
    <div>
      <Header />
      <Container className="vender-casa">
        <div
          className="contact-card p-md-5 p-4 shadow-sm bg-white rounded-3"
          style={{ borderTop: "4px solid #a02020" }}
        >
          <h2
            className="mb-4 fw-bold"
            style={{
              color: "#333",
              borderBottom: "2px solid #f0f0f0",
              paddingBottom: "15px",
            }}
          >
            {texts.contacts.titulo}
          </h2>
          <p className="text-secondary" style={{ fontSize: "1.05rem" }}>
            {texts.contacts.subtitulo}
          </p>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group controlId="nome" className="mb-3">
                  <Form.Label>{texts.contacts.nome}</Form.Label>
                  <Form.Control
                    type="text"
                    name="nome"
                    placeholder={texts.contacts.nomePlaceholder}
                    value={formData.nome}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>{texts.contacts.email}</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder={texts.contacts.emailPlaceholder}
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group controlId="telefone" className="mb-3">
                  <Form.Label>{texts.contacts.telefone}</Form.Label>
                  <Form.Control
                    type="tel"
                    name="telefone"
                    placeholder={texts.contacts.telefonePlaceholder}
                    value={formData.telefone}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="mensagem" className="mb-3">
              <Form.Label>{texts.contacts.mensagem}</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="mensagem"
                placeholder={texts.contacts.mensagemPlaceholder}
                value={formData.mensagem}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <div className="text-center">
              <Button className="mt-3 btn-vender" type="submit">
                <FaEnvelope className="me-2" />
                {texts.contacts.enviar}
              </Button>
              {showAlert && (
                <Alert variant="success" className="mt-3">
                  {texts.contacts.msgOK}
                </Alert>
              )}
              {showError && (
                <Alert variant="danger" className="mt-3">
                  {texts.contacts.msgErro}
                </Alert>
              )}
            </div>
          </Form>
        </div>
      </Container>
      <div className="div-footer">
        <Footer />
      </div>
    </div>
  );
};

export default Contact;
